export const LEGIFRANCE_BASE_URL = 'https://www.legifrance.gouv.fr';
export const LEGIFRANCE_CODES_URL = `${LEGIFRANCE_BASE_URL}/codes/id`;
